import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import classNames from 'classnames';

import { useJobFilterContext } from '../../../contexts/JobFilterProvider.js';
import ButtonWithIcon from '../../shared/ButtonWithIcon/ButtonWithIcon';

import styles from './SearchByButtons.module.scss';

export const SearchByButtons = ({ filters, setfilters }) => {
  const { t } = useTranslation('common');
  const [searchParams] = useSearchParams();

  const { updateSearchParams } = useJobFilterContext();

  useEffect(() => {
    if (!searchParams.size) {
      setfilters((prevFilters) => ({
        ...prevFilters,
        referred: false,
        applied: false,
      }));
    }
  }, [searchParams]);

  const handleReferredOnChange = (value) => {
    updateSearchParams('id', '');
    setfilters((prevFilters) => ({
      ...prevFilters,
      referred: value,
    }));
    updateSearchParams('referred', value);
  };

  const handleAppliedOnChange = (value) => {
    updateSearchParams('id', '');
    setfilters((prevFilters) => ({
      ...prevFilters,
      applied: value,
    }));
    updateSearchParams('applied', value);
  };

  return (
    <div className={styles.SearchBtnContainer}>
      <ButtonWithIcon
        text={t('buttons.appliedJobs')}
        variant="tertiary-36"
        textClassName={styles.btnText}
        containerClass={classNames(styles.buttonCont, { [styles.buttonContActive]: filters?.applied })}
        onClick={() => handleAppliedOnChange(!filters?.applied)}
      />
      <ButtonWithIcon
        text={t('buttons.referredJobs')}
        variant="tertiary-36"
        textClassName={styles.btnText}
        onClick={() => handleReferredOnChange(!filters?.referred)}
        containerClass={classNames(styles.buttonCont, { [styles.buttonContActive]: filters?.referred })}
      />
    </div>
  );
};
